import React, { useRef, useEffect, useState }
from "react";
import {Button}
from "reactstrap";

const Pager = ({template, pager, handlePageChange}) => {

    const pagers = ['<<', '<', '>', '>>'];
    return (
            <div className="mt-3 table-pager-container">
                <div className="table-pager-template-container">{template}</div>
                <div className="table-pager-button-container">
                    {pager.map((page, index) => (
                                        <Button onClick={() => handlePageChange(page)} className="btn-link" color="link">
                                            {pagers[index]}
                                        </Button>
                                            ))}
            
            
                </div>
            </div>
            );
};

export default Pager;
